<inicio class="content"></inicio>

<sobreMi class="content"></sobreMi>

<metodoDeTrabajo class="content"></metodoDeTrabajo>

<areasDeIntervencion class="content"></areasDeIntervencion>

<talleres class="content"></talleres>